import { computed, type ComputedRef } from 'vue';
import { randomTagline } from '@/content/taglines';
import { usePrefsStore } from '@/stores/prefs';

/**
 * One of the wordmark's one-liners, drawn at random.
 *
 * The draw happens once, at setup, rather than inside the computed: a
 * computed re-evaluates whenever anything it touches changes, so picking in
 * there would reshuffle the line every time the reader switched language —
 * and, worse, on any unrelated re-render. Drawing the line once and
 * localising it means it holds still for the life of the component and simply
 * speaks the reader's language.
 */
export function useTagline(): ComputedRef<string> {
  const prefs = usePrefsStore();
  const line = randomTagline();

  return computed(() => line[prefs.prefs.locale] ?? line.en);
}
